import React, { useEffect, useState } from "react";
import {
  Card,
  FormGroup,
  Input,
  Container,
  Row,
  Col,
  Button,
  UncontrolledTooltip,
  CardHeader,
  CardBody,
} from "reactstrap";
import { Link } from "react-router-dom";
import SimpleHeader from "components/Headers/SimpleHeader";
import useApi from "../../hooks/useApi";
import shipmentApi from "api/shipment";
import Spinner from "../../components/Spinner";
import env from "env";
import { useForm, Controller } from "react-hook-form";
import TextPopup from "components/common/TextModal";
import EditAirshipment from "./components/EditAirshipment";
import Pagination from "components/common/Pagination";
import PopupTable from "components/common/PopupTableUsed";
import useAlert from "hooks/useAlert";
import useAbility from "hooks/useAbility";
import FilePicker from "components/common/FilePicker";
import CountryTable from "components/common/CountryTable";
import BulkTable from "components/common/BulkTable";
import bulks from "api/bulks";
import content from "./content";
import commenContent from "components/common/content";

// router
import { useRouteMatch } from "react-router-dom";

// get culture from utils
import getCulture from "utils/getCulture";
import ChangeCargoType from "components/common/ChangeCargoType";
import invoice from "api/invoice";
import useAdvanceSearch from "hooks/useAdvanceSearch";
import useCheckRequest from "hooks/useCheckRequest";
import AdvanceTable from "components/common/AdvanceTable";
import AdvanceSearchModal from "components/common/AdvanceSearchModal";
import { bizznassCustomerCode } from "env";

function Airshipment() {
  const rout = useRouteMatch();
  const culture = getCulture(rout.url);
  const [headers, setHeaders] = useState([
    commenContent.actions[culture],
    content.orderId[culture],
    content.orderBulk[culture],
    content.customerCode[culture],
    content.customerName[culture],
    content.weight[culture],
    content.noOfPackages[culture],
    content.followUpStatus[culture],
    commenContent.country[culture],
    commenContent.date[culture],
    content.receiveDate[culture],
    content.stateDate[culture],
    content.exportDate[culture],
    commenContent.lastModifiedOn[culture],
    commenContent.commodity[culture],
    commenContent.commodityType[culture],
    commenContent.branch[culture],
    commenContent.rate[culture],
  ]);

  const [columns, setColumns] = useState([
    "orderNumber",
    "orderBulk",
    "customer.customerCode",
    "customer.customerName",
    "weight",
    "numberOfPkgs",
    "followUpStatusText",
    "country.name",
    "createdOn",
    "recieveDate",
    "statusDate",
    "exportDate",
    "lastModifiedOn",
    "commodity",
    "commodityTypeText",
    "branch.name",
    "rate",
  ]);

  // useAlert custom hook
  const { alert, sweetAlert } = useAlert();
  const checkAbility = useAbility("AirCargo");
  const bulkCheckAbility = useAbility("AirCargoBulk");

  // Apis
  const getShipmentPreload = useApi(shipmentApi.airCargoPreload);
  const createShipment = useApi(shipmentApi.createAirCargo);
  const updateCargo = useApi(shipmentApi.updateCargo);
  const approveShipment = useApi(shipmentApi.approveShipment);
  const uploadImg = useApi(shipmentApi.uploadImg);
  const getOrderByCode = useApi(shipmentApi.getOrderByCode);
  const getByColumn = useApi(shipmentApi.recivedAdvanceSearch);
  const linkOrderApi = useApi(bulks.linkOrder);
  const changeCargoApi = useApi(invoice.changeCargoType);
  const setTypeStateAsAwaitingChangeApi = useApi(
    shipmentApi.setTypeStateAsAwaitingChange
  );

  // States
  const [data, setData] = useState({});
  const [spinner, setSpinner] = useState(false);
  const [editModal, setEditModal] = useState(false);
  const [editImage, setEditImage] = useState({});
  const [customer, setCustomer] = useState({});
  const [tableModal, setTableModal] = useState(false);
  const [countryTable, setCountryTable] = useState(false);
  const [images, setImages] = useState({});
  const [bulkModal, setBulkModal] = useState(false);
  const [linkModal, setLinkModal] = useState(false);
  const [changeTypeModal, setChangeTypeModal] = useState(false);
  const [changeWaitingStateModal, setChangeWaitingStateModal] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);

  console.log(customer);

  // This varibale holds the page name so when the user navigate to 'air recived details'
  // and then came back i will set him back when he was
  const pageName = "receivedAir";

  const editResponse = (res) => {
    res.orderNumber = `${res.country?.countryCode}-${res.orderNumber}AC`;
    // split date
    res.createdOn = res.createdOn?.split("T")[0];
    res.recieveDate = res.recieveDate?.split("T")[0];
    res.statusDate = res.statusDate?.split("T")[0];
    res.exportDate = res.exportDate?.split("T")[0];
    res.lastModifiedOn = res.lastModifiedOn?.split("T")[0];

    // Replace the normal status with the text from env variable
    const thisStatusIndex = env.followUpStatus.findIndex(
      (status) => status.key === res.followUpStatus
    );

    res.followUpStatusText = env.followUpStatus[thisStatusIndex][culture];

    res.commodityTypeText = env.commodityType?.[res.commodityType - 1];

    if (res.followUpStatus === 6) {
      res.numberOfPkgs = res.restNumberOfPkgs;
      res.weight = res.restlWeight;
    }

    res.orderBulk = (
      <span>
        {res.airBulks?.map((item) => (
          <Link
            to={`/en-admin/bulk/aircargo/${item.id}`}
            className="me-1"
            key={item.id}
          >
            B-{item.bulkPckgNum}
            {item.country?.countryCode}
          </Link>
        ))}
      </span>
    );
    return res;
  };

  // Use form hook
  const {
    handleSubmit,
    formState: { errors },
    control,
    setValue,
    reset,
  } = useForm();
  const {
    handleSubmit: editHandleSubmit,
    formState: editFormState,
    control: editControl,
    setValue: editSetValue,
  } = useForm();
  const {
    handleSubmit: bulkHandleSubmit,
    setValue: bulkSetValue,
    watch: bulkWatch,
  } = useForm();

  const {
    handleSubmit: changeTypeSubmit,
    setValue: changeTypeSetValue,
    formState: { errors: changeTypeErrors },
    control: changeTypeControl,
    reset: changeTypeReset,
  } = useForm();

  // search popup
  const {
    key,
    setKey,
    openPopup,
    setOpenPopup,
    pageNo,
    setPageNo,
    docsPerPage,
    setDocsPerPage,
    register,
    onHeaderClick,
    searchHandler,
    setSearchField,
    header,
    isRemove,
    setIsRemove,
    handleRemove,
  } = useAdvanceSearch(pageName, editResponse);

  const getShipment = async () => {
    const res = await getShipmentPreload.request(
      pageNo,
      docsPerPage
      // sortColumn,
      // isAscending
    );
    if (res.ok) {
      res.data.data.data = res.data.data.data.map((item) => editResponse(item));

      setData(res.data.data);
    }
  };

  const handleCreate = async (formData) => {
    setSpinner(true);

    const schema = new FormData();
    const imgs = images;

    // schema.append('orderId', '');
    schema.append("customerId", customer.id);
    schema.append("countryId", formData.countryId);
    schema.append("followUpStatus", 1);

    delete formData.client;
    delete formData.country;

    Object.keys(formData).forEach((key) => {
      schema.append(key, formData[key]);
    });

    for (let i = 0; i < imgs.length; i++) {
      schema.append("Image", imgs[i]);
    }

    const res = await createShipment.request(schema);
    if (res.status === 200) {
      // const newData = { ...data };
      // Object.keys(res.data.data).forEach(key => {
      //   if (key.includes('date') || key.includes('Date')) {
      //     res.data.data[key] = res.data.data[key] ? res.data.data[key].split('T')[0] : "";
      //   }
      // })

      // res.data.data = editResponse(res.data.data)
      // newData.data.unshift(res.data.data)
      // setData(newData);
      sweetAlert(commenContent.done[culture]);
      reset();
      getShipment();
      setImages({});
    }

    setSpinner(false);
  };

  const handleEdit = (obj) => {
    setEditImage({});
    editSetValue("id", obj.id);
    editSetValue("weight", obj.weight);
    editSetValue("numberOfPkgs", obj.numberOfPkgs);
    editSetValue("country", obj.country.name);
    editSetValue("commodityType", obj.commodityType);
    editSetValue("commodity", obj.commodity);
    editSetValue("countryId", obj.country.id);
    editSetValue("client", obj.customer?.customerName);
    editSetValue("customerId", obj.customer?.id);
    setEditModal(true);
  };

  const handleCancel = () => {
    setEditModal(false);
    setEditImage({});
    setTableModal(false);
    setCountryTable(false);
    setBulkModal(false);
    setImages({});
    setSelectedRow(null);
    setChangeTypeModal(false);
  };

  const handleUpload = async (id) => {
    const res = await uploadImg.request(id, editImage);
    return res?.ok || false;
  };

  const editAirCargo = async (formData) => {
    setSpinner(true);
    setEditModal(false);

    const rowId = { ...formData }.id;
    delete formData.id;
    delete formData.country;

    // Assing 'uploadSucceed' varibale with true default value
    let uploadSucceed = true;

    // if the 'editImage' has 'imgs' attribute and the 'imgs' attribute has a value
    // 1) upload the imgs
    // 2) override the 'uploadSucceed' varibale
    if (Object.keys(editImage).length)
      uploadSucceed = await handleUpload(rowId);

    // if the upload fails don't continue to the next request
    if (!uploadSucceed) return setSpinner(false);
    // if no other filed edited don't continue to the next request
    if (!editFormState.isDirty) {
      // and show success for the upload field
      sweetAlert(commenContent.done[culture]);
      return setSpinner(false);
    }

    const res = await updateCargo.request(rowId, formData);

    if (res.status === 200) {
      const newData = { ...data };
      const editedIndex = newData.data.findIndex((item) => item.id === rowId);

      res.data.data = editResponse(res.data.data);
      newData.data[editedIndex] = res.data.data;

      setData(newData);
      sweetAlert(commenContent.done[culture]);
      setEditImage({});
    }

    setSpinner(false);
  };

  const handleApprove = async (obj) => {
    setSpinner(true);

    const res = await approveShipment.request(obj.id);
    if (res.status === 200) {
      const editedResponse = editResponse(res.data.data);

      const newData = { ...data };
      const index = newData.data.findIndex((item) => item.id === obj.id);
      newData.data[index] = editedResponse;
    }
    setSpinner(false);
  };

  const handleBulk = (obj) => {
    const weight = obj.followUpStatus === 6 ? obj.restlWeight : obj.weight;
    const numberOfPkgs =
      obj.followUpStatus === 6 ? obj.restNumberOfPkgs : obj.numberOfPkgs;

    bulkSetValue("id", obj.id);
    bulkSetValue("weight", weight);
    bulkSetValue("numberOfPkgs", numberOfPkgs);
    setBulkModal(true);
  };

  const linkOrder = async (formData) => {
    setBulkModal(false);
    setLinkModal(false);
    setSpinner(true);
    const schema = {
      id: formData.bulkId,
      orders: [
        {
          id: formData.id,
          weight: formData.weight,
          numberOfPkgs: formData.numberOfPkgs,
        },
      ],
    };
    const res = await linkOrderApi.request("aircargo", schema);

    if (res.status === 200) {
      const index = data.data.findIndex((item) => item.id === formData.id);
      const newData = { ...data };
      editResponse(res.data.data);
      newData.data[index].airBulks.push(res.data.data);
      setData(newData);
    }
    setSpinner(false);
  };

  const updateData = (arr) => {
    // const editedData = arr.map((res) => editResponse(res));
    setData((data) => ({
      ...data,
      data: arr,
    }));
  };

  const renderEdit = (obj) =>
    checkAbility("edit") &&
    (obj.followUpStatus === 5 || obj.followUpStatus === 4);

  const renderLinkBulk = (obj) =>
    bulkCheckAbility("linkOrder") &&
    (obj.airBulks.length === 0 ||
      (obj.airBulks.length === 1 && obj.followUpStatus === 6));

  const renderChangeType = (obj) => obj.shipmentTypeState === 2;

  const renderChangeToWaiting = (obj) => obj.shipmentTypeState === 1;

  const handleChangeType = (obj) => {
    setChangeTypeModal(true);
    changeTypeSetValue("id", obj.id);
  };

  const handleChangeToWaiting = (obj) => {
    setChangeWaitingStateModal(true);
    setSelectedRow(obj);
  };

  const changeToWitingHandler = async () => {
    setChangeWaitingStateModal(false);
    setSpinner(true);

    const res = await setTypeStateAsAwaitingChangeApi.request(selectedRow.id);

    if (res.status === 200) {
      const index = data.data.findIndex((item) => item.id === selectedRow.id);
      const newData = { ...data };
      editResponse(res.data.data);
      newData.data[index].shipmentTypeState = 2;
      setData(newData);
      sweetAlert(commenContent.done[culture]);
    }
    setSelectedRow(null);
    setSpinner(false);
  };

  const changeCargoHandler = async (data) => {
    setSpinner(true);
    setChangeTypeModal(false);
    const res = await changeCargoApi.request(
      data.id,
      { volume: data.volume },
      "lcl"
    );
    if (res.status === 200) {
      setData((oldData) => ({
        ...oldData,
        data: oldData.data.filter((item) => item.id !== data.id),
      }));
      sweetAlert(commenContent.done[culture]);
      changeTypeReset();
    }
    setSpinner(false);
  };

  const handleSearch = async () => {
    setSpinner(true);
    const res = await searchHandler(getByColumn, pageNo, docsPerPage);
    if (res.ok) {
      updateData(res.data.data);
      register({ key: 1, pageNo, docsPerPage, pageName });
    }
    setSpinner(false);
  };

  const closeAdvanceSearch = (index) => {
    handleRemove(index, false);
    setOpenPopup(false);
  };

  useEffect(() => {
    setValue("branchId", customer.currentBranchId);
  }, [customer.currentBranchId]);

  useCheckRequest({
    pageNo,
    isRemove,
    setIsRemove,
    requests: [getShipment, handleSearch],
    setPageNo,
    setDocsPerPage,
    docsPerPage,
    key,
    register,
  });

  return (
    <div>
      {alert}
      {getShipmentPreload.errorAlert}
      {createShipment.errorAlert}
      {updateCargo.errorAlert}
      {approveShipment.errorAlert}
      {uploadImg.errorAlert}
      {getOrderByCode.errorAlert}
      {linkOrderApi.errorAlert}
      {changeCargoApi.errorAlert}
      {spinner ? <Spinner gate="#29bb64" bg="#fff" opacity /> : null}
      {getShipmentPreload.loading ? (
        <Spinner gate="#29bb64" bg="#fff" />
      ) : (
        <>
          <SimpleHeader parents={[content.airShipment[culture]]} />
          <Container className="mt--6" fluid>
            {checkAbility("create") && (
              <Card>
                <CardHeader>
                  <div className="d-flex justify-content-between">
                    <h3 className={`mb-0 text-md-left`}>
                      {content.airShipment[culture]}
                    </h3>
                  </div>
                </CardHeader>
                <CardBody>
                  <form onSubmit={handleSubmit(handleCreate)}>
                    <Row>
                      <Col md="6" lg="4">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="client"
                          >
                            {commenContent.client[culture]}
                          </label>
                          <Controller
                            control={control}
                            name="client"
                            rules={{ required: "Client field is required" }}
                            render={({
                              field: { ref, onChange, value, ...field },
                            }) => (
                              <Input
                                {...field}
                                id="client"
                                placeholder={commenContent.client[culture]}
                                type="text"
                                className={errors.client && "error"}
                                value={value || ""}
                                onChange={({ target: { value } }) =>
                                  onChange(value)
                                }
                                onClick={() => setTableModal(true)}
                              />
                            )}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6" lg="4">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="weight"
                          >
                            {commenContent.weight[culture]}
                          </label>
                          <Controller
                            control={control}
                            name="weight"
                            rules={{ required: "Weight feild is required" }}
                            render={({
                              field: { ref, onChange, value, ...field },
                            }) => (
                              <Input
                                {...field}
                                id="weight"
                                placeholder={commenContent.weight[culture]}
                                type="number"
                                className={errors.weight && "error"}
                                value={value || ""}
                                onChange={({ target: { value } }) =>
                                  onChange(+value)
                                }
                                onWheel={(e) => e.target.blur()}
                              />
                            )}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6" lg="4">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="numberOfPkgs"
                          >
                            {content.numberOfPackages[culture]}
                          </label>
                          <Controller
                            control={control}
                            name="numberOfPkgs"
                            rules={{
                              required: "Number of packages feild is required",
                            }}
                            render={({
                              field: { ref, onChange, value, ...field },
                            }) => (
                              <Input
                                {...field}
                                id="numberOfPkgs"
                                placeholder={content.numberOfPackages[culture]}
                                type="text"
                                className={errors.numberOfPkgs && "error"}
                                value={value || ""}
                                onChange={({ target: { value } }) =>
                                  onChange(+value)
                                }
                              />
                            )}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6" lg="4">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="country"
                          >
                            {commenContent.country[culture]}
                          </label>
                          <Controller
                            control={control}
                            name="country"
                            rules={{ required: "Country feild is required" }}
                            render={({
                              field: { ref, onChange, value, ...field },
                            }) => (
                              <Input
                                {...field}
                                id="country"
                                type="text"
                                className={errors.country && "error"}
                                value={value || ""}
                                placeholder={`-- ${commenContent.selectOption[culture]} --`}
                                onChange={({ target: { value } }) =>
                                  onChange(value)
                                }
                                onClick={() => setCountryTable(true)}
                              />
                            )}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="6" lg="4">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="branch"
                          >
                            {commenContent.branch[culture]}
                          </label>
                          <Controller
                            control={control}
                            name="branchId"
                            rules={{ required: "branch feild is required" }}
                            render={({
                              field: { ref, onChange, value, ...field },
                            }) => (
                              <Input
                                {...field}
                                id="branch"
                                type="select"
                                className={errors.branchId && "error"}
                                value={value || "disabled"}
                                placeholder={`-- ${commenContent.selectOption[culture]} --`}
                                onChange={({ target: { value } }) =>
                                  onChange(value)
                                }
                              >
                                <option disabled value="disabled">
                                  {`-- ${commenContent.selectOption[culture]} --`}
                                </option>
                                {data.branch?.map((item) => (
                                  <option key={item.id} value={item.id}>
                                    {item.name}
                                  </option>
                                ))}
                              </Input>
                            )}
                          />
                        </FormGroup>
                      </Col>
                      <Col md="4">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="commidityType"
                          >
                            {commenContent.commodityType[culture]}
                          </label>
                          <Controller
                            control={control}
                            name="commodityType"
                            rules={{ required: true, min: 1 }}
                            render={({
                              field: { ref, onChange, value, ...field },
                            }) => (
                              <Input
                                {...field}
                                id="commidityType"
                                type="select"
                                defaultValue={0}
                                className={errors.commodityType && "error"}
                                onChange={({ target: { value } }) =>
                                  onChange(+value)
                                }
                              >
                                <option disabled value={0}>
                                  {" "}
                                  {`-- ${commenContent.selectOption[culture]} --`}{" "}
                                </option>
                                {env.commidityType.map((status, i) => (
                                  <option key={i} value={i + 1}>
                                    {status}
                                  </option>
                                ))}
                              </Input>
                            )}
                          />
                        </FormGroup>
                      </Col>
                      {customer.customerCode === bizznassCustomerCode && (
                        <Col md="4">
                          <FormGroup>
                            <label
                              className="form-control-label"
                              htmlFor="buzznassOrderNumber"
                            >
                              {commenContent.buzznassOrderNumber[culture]}
                            </label>
                            <Controller
                              control={control}
                              name="buzznassOrderNumber"
                              rules={{ required: true }}
                              render={({
                                field: { ref, onChange, value, ...field },
                              }) => (
                                <Input
                                  {...field}
                                  id="buzznassOrderNumber"
                                  type="text"
                                  className={
                                    errors.buzznassOrderNumber && "error"
                                  }
                                  onChange={({ target: { value } }) =>
                                    onChange(value)
                                  }
                                  onWheel={(e) => e.target.blur()}
                                />
                              )}
                            />
                          </FormGroup>
                        </Col>
                      )}
                    </Row>
                    <Row>
                      <Col xs="12">
                        <FormGroup>
                          <label
                            className="form-control-label"
                            htmlFor="commodity"
                          >
                            {commenContent.commodity[culture]}
                          </label>
                          <Controller
                            control={control}
                            name="commodity"
                            render={({
                              field: { ref, onChange, value, ...field },
                            }) => (
                              <Input
                                {...field}
                                id="commodity"
                                type="textarea"
                                style={{ resize: "none" }}
                                onChange={({ target: { value } }) =>
                                  onChange(value)
                                }
                              />
                            )}
                          />
                        </FormGroup>
                      </Col>
                    </Row>
                    <FilePicker images={images} setImages={setImages} />
                    <Button color="success" type="submit">
                      <span className="btn-inner--icon me-1">
                        <i className="ni ni-fat-add" />
                      </span>
                      <span>{commenContent.create[culture]}</span>
                    </Button>
                  </form>
                </CardBody>
              </Card>
            )}
            <Card>
              <div className="padding-around pb-0">
                {/* <Row>
                  <Col md="4">
                    <FormGroup>
                      <label className="form-control-label" htmlFor="search">
                        Customer code
                      </label>
                      <Input
                        type="number"
                        placeholder="Search"
                        id="search"
                        value={search}
                        onWheel={(e) => e.target.blur()}
                        onChange={(e) => setSearch(e.target.value)}
                        onKeyPress={(e) => e.key === "Enter" && searchClicked()}
                      />
                    </FormGroup>
                  </Col>
                  <span style={{ paddingTop: 7 }}>
                    <Button
                      color="success"
                      type="button"
                      className="mt-4"
                      onClick={searchClicked}
                    >
                      <span className="btn-inner--icon mr-1">
                        <i className="fas fa-search" />
                      </span>
                      <span>Search</span>
                    </Button>
                  </span>
                </Row> */}
              </div>
              {headers.length && (
                <Pagination
                  dataLength={data.data?.length}
                  pageNo={pageNo}
                  setPageNo={setPageNo}
                  docsPerPage={docsPerPage}
                  setDocsPerPage={setDocsPerPage}
                >
                  <AdvanceTable
                    pageName={pageName}
                    headers={headers}
                    columns={columns}
                    setColumns={setColumns}
                    setHeaders={setHeaders}
                    pageNo={pageNo}
                    // handleSort={handleSort}
                    // when the user search using the popup and select a row
                    // after then only use the hookData states from searchPopup hook
                    data={data.data}
                    setData={(sortedData) =>
                      setData((d) => ({ ...d, data: sortedData }))
                    }
                    handleEdit={handleEdit}
                    handleApprove={handleApprove}
                    handleBulk={handleBulk}
                    renderView={() => checkAbility("view")}
                    renderLinkBulk={renderLinkBulk}
                    renderEdit={renderEdit}
                    handleChangeType={handleChangeType}
                    renderChangeType={renderChangeType}
                    renderChangeToWaiting={renderChangeToWaiting}
                    handleChangeToWaiting={handleChangeToWaiting}
                    searchedHeaders={header}
                    onHeaderClick={onHeaderClick}
                    handleRemove={handleRemove}
                  >
                    <span
                      to={`/${culture}-admin/airshipment`}
                      condition="renderView"
                    >
                      <div
                        id="details1"
                        className="table-action cursor-pointer"
                      >
                        <i className="far fa-eye fa-lg hover-success"></i>
                      </div>
                      <UncontrolledTooltip delay={0} target="details1">
                        {commenContent.showDetails[culture]}
                      </UncontrolledTooltip>
                    </span>
                    <span
                      fun="handleEdit"
                      condition="renderEdit"
                      className="me-1"
                    >
                      <div id="edit1" className="table-action cursor-pointer">
                        <i className="fas fa-pencil-alt fa-lg hover-info" />
                      </div>
                      <UncontrolledTooltip delay={0} target="edit1">
                        {commenContent.edit[culture]}
                      </UncontrolledTooltip>
                    </span>
                    <span
                      fun="handleChangeType"
                      className="me-1"
                      condition="renderChangeType"
                    >
                      <div
                        id="change-type"
                        className="table-action cursor-pointer"
                      >
                        <i className="fas fa-exchange-alt fa-lg hover-warning" />
                      </div>
                      <UncontrolledTooltip delay={0} target="change-type">
                        {commenContent.changeToLcl[culture]}
                      </UncontrolledTooltip>
                    </span>
                    <span
                      fun="handleChangeToWaiting"
                      className="me-1"
                      condition="renderChangeToWaiting"
                    >
                      <div
                        id="change-waiting"
                        className="table-action cursor-pointer"
                      >
                        <i className="far fa-pause-circle hover-warning fa-lg" />
                      </div>
                      <UncontrolledTooltip delay={0} target="change-waiting">
                        {content.changeToWitingChange[culture]}
                      </UncontrolledTooltip>
                    </span>
                    {/* <span fun="handleBulk" condition="renderLinkBulk">
                      <div id="bulk" className="table-action cursor-pointer">
                        <i className="fas fa-shipping-fast hover-primary fa-lg" />
                      </div>
                      <UncontrolledTooltip delay={0} target="bulk">
                        Bulk this shipment
                      </UncontrolledTooltip>
                    </span> */}
                  </AdvanceTable>
                </Pagination>
              )}
              <TextPopup
                modal={editModal}
                text="Update"
                handleCancel={handleCancel}
                fn={editHandleSubmit(editAirCargo)}
                color="success"
                disabled={
                  !editFormState.isDirty && !Object.keys(editImage).length
                }
              >
                <Container>
                  <EditAirshipment
                    control={editControl}
                    errors={editFormState.errors}
                    setValue={editSetValue}
                    editImage={editImage}
                    setEditImage={setEditImage}
                  />
                </Container>
              </TextPopup>
              <TextPopup
                modal={tableModal}
                text="Next"
                handleCancel={handleCancel}
                fn={() => {}}
                color="primary"
                noBtn
              >
                <Container>
                  <PopupTable
                    setCustomer={setCustomer}
                    setTableModal={setTableModal}
                    setValue={setValue}
                    sweetAlert={sweetAlert}
                  />
                </Container>
              </TextPopup>
              <TextPopup
                modal={countryTable}
                text="Next"
                handleCancel={handleCancel}
                fn={() => {}}
                color="primary"
                noBtn
              >
                <Container>
                  <CountryTable
                    setCountryTable={setCountryTable}
                    setValue={setValue}
                    sweetAlert={sweetAlert}
                  />
                </Container>
              </TextPopup>
              <TextPopup
                modal={bulkModal}
                text="Yes"
                handleCancel={handleCancel}
                fn={() => setLinkModal(true)}
                color="primary"
                noBtn
              >
                <Container>
                  <BulkTable
                    setBulkTable={setBulkModal}
                    setLinkModal={setLinkModal}
                    setValue={bulkSetValue}
                    sweetAlert={sweetAlert}
                    shipmentType="aircargo"
                  />
                </Container>
              </TextPopup>
              <TextPopup
                modal={linkModal}
                text="continue"
                handleCancel={() => setLinkModal(false)}
                fn={bulkHandleSubmit(linkOrder)}
                color="success"
              >
                <Container>
                  <h2>
                    You're about to link this order{" "}
                    {
                      data.data?.find((item) => item.id == bulkWatch("id"))
                        ?.orderNumber
                    }
                    with this bulk {bulkWatch("numberOfPkgs")}
                  </h2>
                </Container>
              </TextPopup>
              <TextPopup
                modal={changeTypeModal}
                text={commenContent.change[culture]}
                name={commenContent.changeToLcl[culture]}
                handleCancel={() => setChangeTypeModal(false)}
                fn={changeTypeSubmit(changeCargoHandler)}
                color="success"
              >
                <ChangeCargoType
                  control={changeTypeControl}
                  errors={changeTypeErrors}
                  cargoType="aircargo"
                />
              </TextPopup>
              <TextPopup
                modal={changeWaitingStateModal}
                text={commenContent.continue[culture]}
                handleCancel={handleCancel}
                fn={changeToWitingHandler}
                color="warning"
              >
                <Container>
                  <h2>{content.changeShipmentToWitingChange[culture]}</h2>
                </Container>
              </TextPopup>
              {openPopup && (
                <AdvanceSearchModal
                  setKey={setKey}
                  openPopup={openPopup}
                  pageName={pageName}
                  getByColumn={getByColumn}
                  updateData={updateData}
                  setParentPageNo={setPageNo}
                  setParentDocsPerPage={setDocsPerPage}
                  setParentSearchField={setSearchField}
                  handleClose={closeAdvanceSearch}
                  editResponse={editResponse}
                  extraField={{
                    header: commenContent.orderNumber[culture],
                    column: "orderNumber",
                  }}
                />
              )}
            </Card>
          </Container>
        </>
      )}
    </div>
  );
}

export default Airshipment;
